// @flow
import React, { Component } from 'react';
import CatalogCardContainer from './CatalogCardContainer';
import classNames from 'classnames';
import isEqual from 'react-fast-compare';
import styles from './CatalogGrid.module.scss';

type Props = {
    cardViewModels: any[],
    catalogCardClass: string,
    className: string,
    followed?: boolean,
    homepage: boolean,
    horizontal: boolean,
    preview: boolean,
    showSendSellerConsignmentMessageModal?: Function,
    trackClick?: Function,
};

export default class CatalogGrid extends Component<Props> {
    static defaultProps = {
        catalogCardClass: '',
        className: '',
        homepage: false,
        horizontal: false,
        preview: false,
    };

    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    makeCatalogCards = () => {
        const {
            cardViewModels,
            catalogCardClass,
            homepage,
            horizontal,
            followed,
            preview,
            showSendSellerConsignmentMessageModal,
            trackClick,
        } = this.props;

        const lastIndex = this.props.cardViewModels.length - 1;
        const catalogCardClasses = classNames(styles.card, catalogCardClass);

        // $FlowFixMe
        return cardViewModels.map((card, index) => {
            const cardProps: any = {
                cardViewModel: card,
                followed,
                homepage,
                horizontal,
                key: index,
                last: index === lastIndex,
                preview,
                showSendSellerConsignmentMessageModal,
            };

            // adapts catalog preview cards to a singular card ViewModel
            if (preview && cardProps.cardViewModel.catalogPreview) {
                cardProps.cardViewModel.catalog = Object.assign({}, cardProps.cardViewModel.catalogPreview);
                delete cardProps.cardViewModel.catalogPreview;
            }

            if (trackClick) {
                cardProps.trackClick = () => trackClick(card.catalog.catalogId);
            }

            if (horizontal) {
                return <CatalogCardContainer {...cardProps} />;
            }

            return (
                <div className={catalogCardClasses} key={index}>
                    <CatalogCardContainer {...cardProps} />
                </div>
            );
        });
    };

    render() {
        const classes = classNames(styles['catalog-grid'], this.props.className);
        return <div className={classes}>{this.makeCatalogCards()}</div>;
    }
}
